<template>
  <div id="app">

    <keep-alive :include="include">
      <router-view/>
    </keep-alive>

    <!-- <router-view/> -->

    <article class="load-wrapper" v-if="show">
        <img src="/static/image/icon/loading.gif">
    </article>
  </div>
</template>
<script>
import {mapState} from "vuex"
export default {
  name: 'App',
  data(){
    return {
      include:[ /**缓存的组件 */
        "machineDetails",
        "aisleDetails",
        "replenishmentDetails"
      ]
    }
  },
  computed:{
    ...mapState('load',{
      show:'show'  /**加载中的开启关闭 */
    })
  }
}
</script>



<style lang="stylus" rel="stylesheet/stylus" scoped>

.load-wrapper
  width 100vw
  height 100vh
  line-height 100vh
  position fixed
  z-index 1000
  top 0 
  left 0 
  background #fff
  text-align center
  font-size 1.5rem
  color #464646
  img
    width 30rem
</style>



// WEBPACK FOOTER //
// src/App.vue